var Base = require('_js/base');

function FormDropdown() {}

FormDropdown.prototype = new Base();

FormDropdown.prototype.init = function() {
  $('.form-dropdown-wrapper').on('click', function(event) {
    $(this).toggleClass('active');
    event.stopPropagation();
  });

  // Adjust the styling of the dropdown on mobile.
  var $mobileDropdownsContainer = $('.form-dropdown-wrapper.dropdown-mobile');
  var $mobileDropdowns = $mobileDropdownsContainer.find('.dropdown');
  var globalPadding = 12;
  // Only listen to window resize if we find some mobile dropdowns.
  if ($mobileDropdowns.get(0) !== 'undefined') {
    $(window).on('resize', function() {
      $mobileDropdowns.css({
        'max-width': $(this).width() - globalPadding * 2,
        'min-width': $(this).width() - globalPadding * 2
      });
    });
  }
};

FormDropdown.prototype.start = function(dataId, container) {
  $(container).on('click', dataId, function(event) {
    $(this)
      .parent()
      .toggleClass('active');
    event.stopPropagation();
  });
};
module.exports = FormDropdown;
